import { ADDED, REMOVED } from './offer';
import { joinWithSpace } from './string';

export const REMOVED_OFFERS_QUERY_ARGS = `statuses: [${joinWithSpace(
  REMOVED,
)}]`;
export const ADDED_OFFERS_QUERY_ARGS = `statuses: [${joinWithSpace(ADDED)}]`;
export const ACTIVE_OFFERS_QUERY_ARGS = `${ADDED_OFFERS_QUERY_ARGS}, campaignStatuses: [active]`;
